<script setup lang="ts">
import { inject, type Ref } from 'vue'
import type { Room } from '@/models/Room'
import Heading from './Heading.vue'

const room = inject('room') as Ref<Room | null>
</script>

<template>
  <Heading>
    <img src="./assets/room.svg" class="room" alt="Local" />
    <div class="info">
      <div>Local : {{ room?.number }}</div>
      <div>Bâtiment : {{ room?.buildingName }}</div>
    </div>
  </Heading>
</template>

<style scoped lang="scss">
.heading {
  justify-content: flex-start;

  img.room {
    height: 42px;
  }

  .info {
    margin-left: 15px;
    > div {
      font-size: 15px;
      font-weight: 500;
      line-height: 20px;
    }
  }
}
</style>
